import React, { useMemo, useContext } from 'react'
import GraphTable from '../mechanisms/graphtable';
import { currencyPrefix } from '../single-card';
import { formatCurrency } from '../functions';
import { aggregateData } from '../functions';
import DashView from '../mechanisms/dashview';
import { DashboardContext } from '../mechanisms/card';

const QualifiedOpportunitiesDashboard = ({ data = [] }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => {
        const total_dict = {}

        const agg_data = aggregateData('value', data.flatMap(d => {
            total_dict[d.owner_id] = (total_dict[d.owner_id] || 0) + 1
            if (d.status !== 'QUALIFIED') return []
            return d
        }), 'owner_id')

        agg_data.forEach(row => {
            row.conversion = Math.round((row.count / (total_dict[row.owner_id] || 1)) * 10000) / 100
        })

        return agg_data
    }, [data])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'owner_name', headerName: 'Vendedor', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'value', headerName: 'Valor', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                },
                {
                    field: 'conversion', headerName: 'Taxa de qualificação', flex: 1,
                    renderCell: ({ value }) => `${value} %`
                }
            ]} />
                : <DashView name='qualifiedopportunities' rows={graph} vx='owner_name' vy={['count', 'value', 'conversion']} renderValue={(vy, row) => {
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    else if (vy === 'conversion')
                        return  `${row[vy]} %`
                    return row[vy]
                }}
                />
            }
        </>)
}


export default QualifiedOpportunitiesDashboard
